import { HiArrowRight } from 'react-icons/hi';
import { PropertyCardData } from '../PropertyCardCarousel';
import {
  CardRoot,
  CoverImage,
  CtaButton,
  Description,
  MetaRow,
  Panel,
  PriceBlock,
  Title,
  UnitBlock,
} from './styles';

const PLACEHOLDER_IMG = '/images/placeholder-image-nogueira.png';

function formatBRL(value?: number) {
  if (value == null || Number.isNaN(Number(value))) {
    return 'Sob consulta';
  }

  return Number(value).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });
}

function buildLocationLabel(data: PropertyCardData) {
  const place = [data.bairro, data.cidade].filter(Boolean).join(', ');
  if (data.idDisplay && place) return { id: data.idDisplay, place };
  if (data.idDisplay) return { id: data.idDisplay, place: '' };
  return { id: '', place };
}

function buildDescription(data: PropertyCardData) {
  return [data.descricao, data.enderecoCompleto].filter(Boolean).join(' ');
}

export type { PropertyCardData };

export function PropertyCardFeatured(props: PropertyCardData) {
  const { id, place } = buildLocationLabel(props);
  const description = buildDescription(props);
  const imageSrc = props.imageUrl || PLACEHOLDER_IMG;

  const handleNavigate = () => {
    const path = props.isEmpreendimento
      ? `/empreendimento/${props.id}`
      : `/imovel/${props.id}`;
    window.open(path, '_blank', 'noopener,noreferrer');
  };

  return (
    <CardRoot>
      <CoverImage
        src={imageSrc}
        alt="Imagem do imóvel"
        onError={(e) => {
          e.currentTarget.src = PLACEHOLDER_IMG;
        }}
        onClick={handleNavigate}
      />

      <Panel onClick={(e) => e.stopPropagation()}>
        <Title>
          {id ? (
            <b>
              {id}
              {place ? ' - ' : ''}
            </b>
          ) : null}
          {place}
        </Title>

        <Description title={description || undefined}>{description}</Description>

        <MetaRow>
          <PriceBlock>
            <p>A partir de:</p>
            <div>
              <b>{formatBRL(props.valorVenda)}</b>
              <span className="asterisk"> *</span>
            </div>
            <p className="disclaimer">* Sujeito a disponibilidade</p>
          </PriceBlock>

          <UnitBlock>
            {props.apBloco != null && props.apBloco !== '' && (
              <p>Bloco: {props.apBloco}</p>
            )}
            {props.apNumero != null && props.apNumero !== '' && (
              <p>Unidade: {props.apNumero}</p>
            )}
          </UnitBlock>
        </MetaRow>

        <CtaButton type="button" onClick={handleNavigate}>
          Ver imóvel
          <HiArrowRight />
        </CtaButton>
      </Panel>
    </CardRoot>
  );
}
